<template>
  <AdvancedSearch v-show="functionStatus == '高级搜索'"/>
</template>

<script>
import AdvancedSearch from '../components/GaoJiSouSuo/AdvancedSearch.vue'
import { mapState } from 'vuex'
export default {
  components: {
    AdvancedSearch,
  },
  computed: {
    ...mapState(['functionStatus']),
  },
}
</script>

<style lang="less" scoped>
</style>